import React from 'react'
import './main.css'

export default function GlazingCottages() {
  return (
    <div>Glazing</div>
  )
}
